module.exports = __webpack_public_path__ + "static/media/Gotham-BoldItalic.ae01968e.woff2";